import { useState } from 'react';
import { ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import authService from '../api/authService';
import { Button, Input, Alert } from '@/shared/components/ui';
import { MENSAJES_EXITO, TEXTOS_UI } from '../constants';

export const RecuperarContrasenaForm = () => {
    const [identificador, setIdentificador] = useState('');
    const [esExitoso, setEsExitoso] = useState(false);
    const [estaCargando, setEstaCargando] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const manejarEnvio = async (e: React.FormEvent) => {
        e.preventDefault();
        setEstaCargando(true);
        setError('');

        try {
            await authService.solicitarRecuperacion(identificador);
            setEsExitoso(true);
        } catch (err: any) {
            setError(err.response?.data?.message || 'Error al procesar solicitud');
        } finally {
            setEstaCargando(false);
        }
    };

    if (esExitoso) {
        return (
            <form className="login-form">
                <Alert type="success">{MENSAJES_EXITO.RECUPERACION_ENVIADA}</Alert>
                <Button
                    type="button"
                    onClick={() => navigate('/login')}
                    variant="primary"
                    fullWidth
                    className="login-btn"
                >
                    {TEXTOS_UI.RECUPERACION_VOLVER_LOGIN}
                </Button>
            </form>
        );
    }

    return (
        <form className="login-form" onSubmit={manejarEnvio}>
            <Input
                id="identificador"
                type="text"
                label={TEXTOS_UI.RECUPERACION_LABEL}
                value={identificador}
                onChange={(e) => setIdentificador(e.target.value)}
                placeholder={TEXTOS_UI.RECUPERACION_PLACEHOLDER}
                className="form-input"
                required
                disabled={estaCargando}
                autoFocus
                noMargin
            />

            {error && <Alert type="error">{error}</Alert>}

            <Button
                type="submit"
                variant="primary"
                fullWidth
                disabled={estaCargando}
                loading={estaCargando}
                className="login-btn"
            >
                {TEXTOS_UI.RECUPERACION_BOTON}
            </Button>

            <button
                type="button"
                onClick={() => navigate('/login')}
                className="back-btn"
            >
                <ChevronLeft size={16} />
                {TEXTOS_UI.LOGIN_REGRESAR_BOTON}
            </button>
        </form>
    );
};
